'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * GET content/categories/v1/categories/meta
 */

export function fetch() {
  return http.get('content/categories/v1/categories/meta');
}